import { render } from "./customSetting.vue?vue&type=template&id=2640e4b6"
import script from "./customSetting.vue?vue&type=script&lang=js"
export * from "./customSetting.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__